import { Message } from 'element-ui';
// import store from '@/store';
import fetch from './fetch';

async function request({
  url, method, params, data, isAutoShowErrorTip = true,
}) {
  let isError = false;

  const response = await fetch[method](url, params || data)
    .catch((error) => { isError = true; return error; });

  if (isError && isAutoShowErrorTip) {
    Message({
      message: response.message,
      type: 'error',
      duration: 5000,
    });
  }

  return { data: response, isError };
}

export function get({ url, data, isAutoShowErrorTip }) {
  return request({
    method: 'get',
    url,
    params: data,
    isAutoShowErrorTip,
  });
}

export function post({ url, data, isAutoShowErrorTip }) {
  return request({
    method: 'post',
    url,
    data,
    isAutoShowErrorTip,
  });
}

export function put({ url, data, isAutoShowErrorTip }) {
  return request({
    method: 'put',
    url,
    data,
    isAutoShowErrorTip,
  });
}

export function patch({ url, data, isAutoShowErrorTip }) {
  return request({
    method: 'patch',
    url,
    data,
    isAutoShowErrorTip,
  });
}

export function del({ url, data, isAutoShowErrorTip }) {
  return request({
    method: 'del',
    url,
    params: data,
    isAutoShowErrorTip,
  });
}

export function head({ url, data, isAutoShowErrorTip }) {
  return request({
    method: 'head',
    url,
    params: data,
    isAutoShowErrorTip,
  });
}
